<template>
  <div class="box">
    <!-- 循环订单信息 -->
    <div v-for="(item, index) in  list " :key="index" class="bgc" @click="goOrderDetail(item)">
      <div class="flex jcsb">
        <div class="order-number-section">
          <span class="order-number">订单编号:{{ item.orderNo }}</span>
          <span class="copy-btn" @click.stop="copyOrderNo(item.orderNo)">复制</span>
        </div>
      </div>
      <!-- 统一的商品信息显示 -->
      <div v-if="item.orderDetail" class="product-item">
        <img :src="getPic(item)" alt="" class="product-img" />
        <div class="product-info">
          <div class="product-header">
            <div class="product-name">{{ item.productName }}</div>
            <div class="order-status-tag" :class="getStatusClass(item.status)">{{ item.statusT }}</div>
          </div>
          <div class="product-bottom">
            <div class="product-quantity">x{{ item.productNum }}</div>
          </div>
        </div>
      </div>
      <div v-else v-for="(item2, index) in item.productSubOrderList" :key="index" class="product-item">
        <img :src="getPic(item, item2)" alt="" class="product-img" />
        <div class="product-info">
          <div class="product-header">
            <div class="product-name">{{ item2.productName }}</div>
            <div class="order-status-tag" :class="getStatusClass(item2.status)">{{ item2.statusT }}</div>
          </div>
          <div v-if="item2.skuName" class="product-spec">{{ item2.skuName }}</div>
          <div v-if="item2.tastesName" class="product-taste">口味：{{ item2.tastesName }}</div>
          <div class="product-bottom">
            <div class="product-quantity">x{{ item2.emptionNum }}</div>
          </div>
        </div>
      </div>
      <div class="order-price-section">
        <div class="price-left"></div>
        <div class="price-right">
          <div v-if="item.status !== '4' && item.status !== '5'" class="price-main">
            <span v-if="item.status == '0'" class="price-label">需付款：</span>
            <span v-else class="price-label">实付款：</span>
            <span v-if="item.payProductTotal" class="price-amount">{{ item.payProductTotal }}{{ item.cardPointTypeUnit || '点' }}</span>
          </div>
          <div v-if="item.userRefundAmount" class="refund-info">
            （已退{{ item.userRefundAmount }}{{ item.cardPointTypeUnit || '点' }}）
          </div>
        </div>
      </div>
      <!-- 收货地址信息 -->
      <div v-if="item.status === '0'" class="flex jce" style="margin-top: 1rem;">
        <div class="action-btn action-btn-secondary" @click.stop="cancelOrder(index)">
          取消订单
        </div>
        <div class="action-btn action-btn-primary" @click.stop="goPay(index)">
          去支付
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CakeOrder",
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  components: {},
  methods: {
    getPic(str, st2) {
      if (str.orderDetail) {
        return JSON.parse(str.orderDetail).moviePicUrl
      } else {
        return st2.url
      }

    },
    //去支付
    goPay(index) {
      this.$emit('goPay', index)
    },
    //取消订单
    cancelOrder(val) {
      this.$emit('onCancelOrder', val)
    },
    goOrderDetail(val) {
      const isMovie = val.productType === '2' || val.orderDetail;
      if (isMovie) {
        this.$router.push({
          path: '/OrderDetail',
          query: { orderNo: val.orderNo },
        });
      } else {
        this.$router.push({
          path: '/CakaOrderDetail',
          query: { orderNo: val.orderNo },
        });
      }
    },
    copyOrderNo(orderNo) {
      // 统一复制功能实现
      if (navigator.clipboard) {
        navigator.clipboard.writeText(orderNo).then(() => {
          this.$Toast('复制成功');
        }).catch(() => {
          this.fallbackCopy(orderNo);
        });
      } else {
        this.fallbackCopy(orderNo);
      }
    },
    fallbackCopy(text) {
      // 兼容性复制方法
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.$Toast('复制成功');
      } catch (err) {
        this.$Toast('复制失败');
      }
      document.body.removeChild(textArea);
    },    
    getStatusClass(status) {
      if (status == '0') return 'status-payment'
      return 'status-other'
    },
  },
  mounted() {
    // console.log(this.list);
  },
  computed: {},
  watch: {},
};
</script>

<style lang='scss' scoped>
.box {
  background-color: #f8f8f8;
  overflow-x: hidden;

  .bgc {
    background-color: #fff;
    border-radius: 0.8rem;
    margin: 1rem 1.1rem 0 1.1rem;
    padding: 1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
}

/* ========== 统一商品信息样式 ========== */
.product-item {
  display: flex;
  align-items: flex-start;
  margin-top: 0.8rem;
  gap: 0.8rem;
  min-width: 0;
  overflow: hidden;
}

.product-img {
  width: 5rem;
  height: 5rem;
  border-radius: 0.6rem;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.product-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 5rem;
  justify-content: space-between;
  overflow: hidden;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.3rem;
  gap: 0.5rem;
}

.product-name {
  flex: 1;
  font-size: 0.9rem;
  color: #333;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-width: 0;
}

.product-spec,
.product-taste {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  font-size: 0.8rem;
  color: #999;
  line-height: 1.3;
  margin-bottom: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.product-bottom {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.product-quantity {
  font-size: 0.8rem;
  color: #999;
  font-weight: 500;
}

/* ========== 价格区域样式 ========== */
.order-price-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.8rem;
}

.price-left {
  flex: 1;
}

.price-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.price-main {
  display: flex;
  align-items: center;
  margin-bottom: 0.2rem;
}

.price-label {
  font-size: 0.85rem;
  color: #666;
  margin-right: 0.3rem;
}

.price-amount {
  font-size: 0.95rem;
  font-weight: 600;
  color: #D23B2E;
}

.refund-info {
  font-size: 0.75rem;
  color: #999;
}





.order-number-section {
  display: flex;
  align-items: center;
  flex: 1;
}

.order-number {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}

/* ========== 统一复制按钮样式 ========== */
.copy-btn {
  margin-left: 0.5rem;
  padding: 0.1rem 0.4rem;
  background: rgba(102, 102, 102, 0.1);
  color: #666;
  font-size: 0.75rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(102, 102, 102, 0.3);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: inline-block;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.copy-btn:active {
  background: rgba(102, 102, 102, 0.2) !important;
  transform: scale(0.95) !important;
}
/* ========== 复制按钮样式结束 ========== */

/* ========== 统一操作按钮样式 ========== */
.action-btn {
  display: inline-block;
  padding: 0;
  border-radius: 1rem;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  height: 1.8rem;
  line-height: 1.8rem;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  border-width: 0.5px;
  border-style: solid;
  flex-shrink: 0;
  min-width: 4rem;
  max-width: calc(45% - 0.3rem);
  vertical-align: middle;
  text-align: center;
}

.action-btn + .action-btn {
  margin-left: 0.5rem;
}

.action-btn-primary {
  background-image: linear-gradient(left, #ffcf7a 0%, #ffa976 100%);
  color: #f5f5f5;
  border-color: rgba(255, 207, 122, 0.3);
}

.action-btn-primary:active {
  background-image: linear-gradient(left, #f5c470 0%, #f59e6c 100%);
  transform: scale(0.98) !important;
}

.action-btn-secondary {
  background: rgba(102, 102, 102, 0.05);
  color: #666666;
  border-color: rgba(102, 102, 102, 0.3);
}

.action-btn-secondary:active {
  background: rgba(102, 102, 102, 0.12) !important;
  transform: scale(0.98) !important;
}
/* ========== 操作按钮样式结束 ========== */

/* ========== 订单状态标签样式 ========== */
.order-status-tag {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.3rem 0.6rem;
  border-radius: 0.6rem;
  white-space: nowrap;
  flex-shrink: 0;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  min-width: fit-content;
  text-align: center;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* 待支付 - 红色渐变 */
.order-status-tag.status-payment {
  background: linear-gradient(135deg, #FF6B6B 0%, #D23B2E 100%);
  color: white;
  box-shadow: 0 3px 8px rgba(210, 59, 46, 0.25);
}

/* 其他状态 - 蓝色渐变 */
.order-status-tag.status-other {
  background: linear-gradient(135deg, #4DABF7 0%, #1890FF 100%);
  color: white;
  box-shadow: 0 3px 8px rgba(24, 144, 255, 0.25);
}
</style>